import React, { useState, useEffect } from "react";
import { Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { toBase64 } from "./ImageConvert"; // must return a base64 string

const { Dragger } = Upload;

const ImageUpload = ({ value, onChange, mode = "add", type = "single" }) => {
    const [fileList, setFileList] = useState([]);

    useEffect(() => {
        const prepareFiles = async () => {
            if (mode === "edit" && value) {
                let files = Array.isArray(value) ? value : [value]; // ensure array

                const base64Files = await Promise.all(
                    files.map(async (file, index) => {
                        if (file.originFileObj) {
                            return {
                                ...file,
                                status: "done",
                                url: await toBase64(file.originFileObj),
                            };
                        } else if (file instanceof File) {
                            return {
                                uid: `init-${index}`,
                                name: file.name,
                                status: "done",
                                url: await toBase64(file),
                            };
                        } else if (typeof file === "string") {
                            return {
                                uid: `init-${index}`,
                                name: `image-${index}`,
                                status: "done",
                                url: file,
                            };
                        }
                        return file;
                    })
                );

                setFileList(base64Files);
            }
        };

        prepareFiles();
    }, [mode, value]);

    const handleChange = async ({ fileList: newFileList }) => {
        setFileList(newFileList);

        // convert to base64 if needed
        const base64Files = await Promise.all(
            newFileList.map(async (file) => {
                if (file.originFileObj) {
                    const base64 = await toBase64(file.originFileObj);
                    return {
                        ...file,
                        base64, // actual base64 string
                    };
                }
                return file;
            })
        );

        onChange?.(base64Files); // send back resolved objects, not promises
    };


    const handleRemove = (file) => {
        const updated = fileList.filter((item) => item.uid !== file.uid);
        setFileList(updated);
        onChange?.(updated);
    };

    return (
        <Dragger
            multiple={type !== "single"}
            beforeUpload={() => false} // prevent auto-upload
            fileList={fileList}
            onChange={handleChange}
            onRemove={handleRemove}
            maxCount={type === "single" ? 1 : 5}
            listType="picture"
        >
            <p className="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p className="ant-upload-text">
                {mode === "edit" ? "Update files here" : "Click or drag files to upload"}
            </p>
            <p className="ant-upload-hint">Support multiple file uploads</p>
        </Dragger>
    );
};

export default ImageUpload;
